
<template>
  <v-row justify="center">
    <v-col cols="12">
      <v-card>
        <v-card-text>
          <v-row class="justify-center">
            <v-col>
              <v-tabs>
                <v-tab>
                  <v-icon left>
                    mdi-receipt
                  </v-icon>Основное
                </v-tab>
                <v-tab>
                  <v-icon left>
                    mdi-receipt
                  </v-icon>Позиции прихода
                </v-tab>
                <v-tab-item>
                  <v-row class="justify-center">
                    <v-col
                      v-if="!create"
                      cols="12"
                    >
                      <v-text-field
                        readonly
                        :value="formatDateTime(form.created)"
                        label="Дата создания"
                      />
                    </v-col>
                    <v-col
                      v-if="!create"
                      cols="12"
                    >
                      <v-text-field
                        v-model="form.number"
                        readonly
                        label="Номер прихода"
                      />
                    </v-col>
                    <v-col
                      v-if="!create"
                      cols="12"
                      sm="6"
                    >
                      <v-text-field
                        readonly
                        :value="form.creator.name"
                        label="Кто создал"
                      />
                    </v-col>
                    <v-col
                      v-if="!create && form.changer"
                      cols="12"
                      sm="6"
                    >
                      <v-text-field
                        readonly
                        :value="form.changer.name"
                        label="Кто изменил"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                    >
                      <v-autocomplete
                        v-model="form.client"
                        label="Клиент"
                        type="autocomplete"
                        :items="clients"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                    >
                      <v-autocomplete
                        v-model="form.supplier"
                        label="Поставщик"
                        :items="suppliers"
                      />
                    </v-col>
                    <v-col
                      v-if="!create"
                      cols="12"
                    >
                      <v-checkbox
                        v-model="form.status"
                        readonly
                        :label="form.status ? 'Проведёно' : 'Не проведено'"
                      />
                    </v-col>
                  </v-row>
                </v-tab-item>
                <v-tab-item>
                  <v-row class="justify-center">
                    <!--                    <v-col-->
                    <!--                      cols="12"-->
                    <!--                    >-->
                    <!--                      <v-autocomplete-->
                    <!--                        v-model="form.nomenclature"-->
                    <!--                        label="Номенклатура"-->
                    <!--                        type="autocomplete"-->
                    <!--                        :items="nomenclatures"-->
                    <!--                      />-->
                    <!--                    </v-col>-->
                    <!--                    <v-col-->
                    <!--                      cols="12"-->
                    <!--                    >-->
                    <!--                      <v-text-field-->
                    <!--                        v-model="form.purchasePrice"-->
                    <!--                        label="Закупочная цена"-->
                    <!--                      />-->
                    <!--                    </v-col>-->
                    <!--                    <v-col-->
                    <!--                      cols="12"-->
                    <!--                    >-->
                    <!--                      <v-text-field-->
                    <!--                        v-model="form.quantity"-->
                    <!--                        type="number"-->
                    <!--                        label="Количество"-->
                    <!--                      />-->
                    <!--                    </v-col>-->
                    <v-col
                      cols="12"
                    >
                      <v-autocomplete
                        v-model="form.point"
                        label="Точка"
                        type="autocomplete"
                        :items="points"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      sm="4"
                    >
                      <v-btn
                        color="primary"
                        outlined
                        large
                        min-width="100"
                        class="mr-5"
                        @click="() => onShowChooseNomenclatureDialog()"
                      >
                        Добавить
                      </v-btn>
                    </v-col>
                    <v-col cols="12">
                      <div
                        style="display: flex; flex-direction: row; cursor: pointer;"
                        class="ml-2 mb-3"
                        @click="onDeleteSelectedNomenclatures()"
                      >
                        <div>
                          <v-icon
                            medium
                            color="#aaaaaa"
                            class="mr-1"
                          >
                            mdi-delete
                          </v-icon>
                        </div>
                        <div style="color: #aaaaaa">
                          Убрать выбранные из таблицы
                        </div>
                      </div>
                      <v-data-table
                        v-model="selectedNomenclature"
                        :items-per-page="10"
                        dense
                        :items="form.nomenclatures"
                        :headers="[
                          {sortable: false, value: 'delete', text: 'Убрать'},
                          {value: 'code', text: 'Артикул'},
                          {value: 'name', text: 'Название'},
                          // {text: 'Тип', value: 'type'},
                          {text: 'Ставка НДС', value: 'tax'},
                          {value: 'price', text: 'Цена'},
                          {value: 'quantity', text: 'Количество'},
                          // {value: 'category', text: 'Категория'},
                          // {value: 'subcategory', text: 'Подкатегория'},
                          // {value: 'subsubcategory', text: 'Подподкатегория'},
                        ]"
                        :footer-props="datatable_footer"
                        no-data-text="Нет данных для отображения"
                        show-select
                      >
                        <template v-slot:item.quantity="{item}">
                          <v-text-field
                            v-model="item.quantity"
                            type="number"
                            label="Количество"
                          />
                        </template>
                        <template v-slot:item.delete="{ item }">
                          <v-icon
                            color="#aaaaaa"
                            class="mr-2"
                            style="cursor: pointer;"
                            @click="onDeleteNomenclature(item)"
                          >
                            mdi-delete
                          </v-icon>
                        </template>
                        <template v-slot:footer.page-text="{pageStart, pageStop, itemsLength}">
                          {{ pageStart }}-{{ pageStop }} из {{ itemsLength }}
                        </template>
                      </v-data-table>
                    </v-col>
                  </v-row>
                </v-tab-item>
              </v-tabs>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="d-flex justify-sm-space-around">
          <v-row justify-lg="center">
            <v-col
              cols="12"
              sm="4"
              lg="3"
            >
              <v-btn
                block
                color="primary"
                outlined
                @click="$router.go(-1)"
              >
                <span class="mx-3">Назад</span>
              </v-btn>
            </v-col>
            <v-col
              v-if="!view && !form.status"
              cols="12"
              sm="4"
              lg="3"
            >
              <v-btn
                block
                color="primary"
                class="ml-auto"
                @click="onSave"
              >
                <span class="mx-3">Сохранить</span>
              </v-btn>
            </v-col>
            <v-col
              v-if="!view && !create && !form.status"
              cols="12"
              sm="4"
              lg="3"
            >
              <v-btn
                block
                color="primary"
                class="ml-auto"
                @click="onConduct"
              >
                <span class="mx-3">Провести</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-col>
    <v-dialog
      v-model="dialog.nomenclature.show"
      persistent
      max-width="80%"
    >
      <v-card>
        <v-card-title>Выберите номенклатуры</v-card-title>
        <v-card-text>
          <div>
            <v-data-table
              v-model="dialog.nomenclature.data"
              :items-per-page="10"
              dense
              :items="select.nomenclature"
              :headers="[
                {value: 'name', text: 'Название'},
                {value: 'code', text: 'Артикул'},
                {value: 'price', text: 'Цена'},
                // {value: 'category', text: 'Категория'},
                // {value: 'subcategory', text: 'Подкатегория'},
                // {value: 'subsubcategory', text: 'Подподкатегория'},
              ]"
              :footer-props="datatable_footer"
              no-data-text="Нет данных для отображения"
              show-select
            />
          </div>
        </v-card-text>
        <v-card-actions>
          <div
            class="mx-5"
            style="width: 100%"
          >
            <v-row class="justify-center">
              <v-col
                cols="6"
              >
                <v-btn
                  color="primary"
                  outlined
                  large
                  min-width="100"
                  @click="onCloseNomenclatureDialog()"
                >
                  <span class="mx-3">Закрыть</span>
                </v-btn>
              </v-col>
              <v-col
                cols="6"
                class="d-flex justify-end"
              >
                <v-btn
                  color="primary"
                  large
                  min-width="200"
                  @click="onAddNomenclature()"
                >
                  Добавить
                </v-btn>
              </v-col>
            </v-row>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script >
import { JustpayRevenueService } from "@/views/loyalty/shared/services/justpay-revenue-service"
import moment from "moment/moment"

export default {
  props: ['create', 'change', 'view', 'show', 'item'],
  data: () => ({
    clients: [],
    datatable_footer: {
      itemsPerPageText: 'Показывать по',
      pageText: 'из',
      itemsPerPageAllText: 'Все',
    },
    dialog: {
      nomenclature: {
        show: false,
        data: [],
        page: {}
      }
    },
    dialogNomenclatureShow: false,
    goodsForVending: [],
    form: {
      created: null,
      number: null,
      nomenclatures: [],
      point: null,
      status: 0,
      supplier: null,

    },
    justpayRevenueService: null,
    nomenclatures: [],
    points: [],
    select: {
      nomenclature: []
    },
    selectedNomenclature: [],
    suppliers: []
  }),
  beforeMount () {
    this.justpayRevenueService = new JustpayRevenueService()
  },
  async mounted () {
    let response = {}
    const revenueId = this.$route.query.id
    response = await this.justpayRevenueService.getRevenue(revenueId)
    if (revenueId) {
      console.log('response', response)
      this.form = response.data
    }
    this.clients = response.clients
    this.nomenclatures = response.nomenclatures
    this.points = response.points
    this.select.nomenclature = JSON.parse(JSON.stringify(response.nomenclatures))
    this.suppliers = response.suppliers
  },
  methods: {
    formatDateTime: function (date) {
      return moment(date).format('DD.MM.YYYY HH:mm:ss')
    },
    onAddNomenclature () {
      const previously_selected_nomenclatures_id = this.form.nomenclatures.map(a => a.id)
      this.form.nomenclatures.push(
          ...this.dialog.nomenclature.data.filter(
              a => (
                  !previously_selected_nomenclatures_id.includes(a.id)
              )
          ).map(a => Object.assign({}, a))
      )
      this.dialog.nomenclature.page = {}
      this.dialog.nomenclature.data = []
      this.dialog.nomenclature.show = false
    },
    onCloseNomenclatureDialog () {
      this.dialog.nomenclature.page = {}
      this.dialog.nomenclature.data = []
      this.dialog.nomenclature.show = false
    },
    async onConduct () {
      if (this.form.id) {
        await this.justpayRevenueService.conductRevenue(this.form)
      }
      this.$router.go(-1)
    },
    onDeleteNomenclature (item) {
      console.log("onDeleteNomenclature")
      this.form.nomenclatures = this.form.nomenclatures.filter(a => a.id !== item.id)
    },
    onDeleteSelectedNomenclatures () {
      console.log("onDeleteSelectedNomenclatures")
      const selected_nomenclatures_id = this.selectedNomenclature.map(a => a.id)
      this.form.nomenclatures = this.form.nomenclatures.filter(a => !selected_nomenclatures_id.includes(a.id))
      this.selectedNomenclature = []
    },
    async onSave () {
      if (this.form.id) {
        await this.justpayRevenueService.changeRevenue(this.form)
      } else {
        await this.justpayRevenueService.createRevenue(this.form)
      }
      this.$router.go(-1)
    },
    onShowChooseNomenclatureDialog () {
      this.dialog.nomenclature.show = true
      this.dialog.nomenclature.data = []
      this.dialog.nomenclature.show = true
    }
  },
}
</script>

<style scoped>

</style>
